import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PrimaryButton, SecondaryButton } from "../components/common";

export default function ThankYou() {
  return (
    <section className="container-page flex min-h-[70vh] flex-col items-center justify-center py-20 text-center" data-testid="thank-you">
      <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 14 }} className="flex h-20 w-20 items-center justify-center rounded-full bg-brand-primary text-white">
        <Check className="h-9 w-9" />
      </motion.span>
      <h1 className="mt-8 font-heading text-[32px] font-800 text-brand-ink md:text-[44px]">Thank you — your enquiry has been received.</h1>
      <p className="mt-4 max-w-xl text-[17px] text-brand-muted md:text-[18px]">We will review your requirement and respond via your preferred contact method with a practical next step.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <PrimaryButton to="/" testid="thankyou-home">Return Home</PrimaryButton>
        <SecondaryButton to="/services" testid="thankyou-services">Explore Services</SecondaryButton>
      </div>
    </section>
  );
}
